import { Component, OnInit } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserApi } from 'src/app/models/api_models/user';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-user-edit-password',
  templateUrl: './user-edit-password.component.html',
  styleUrls: ['./user-edit-password.component.css']
})
export class UserEditPasswordComponent implements OnInit {

  public loaded = false;
  public currentUser: UserApi = null;

  public getUserImg() {
    if (this.currentUser.profile_picture !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.profile_picture.mimetype};base64,${this.currentUser?.profile_picture.file}`)
    }
  }

  newPassword: string = "";
  currentPassword: string = "";
  verifPassword: string = "";


  public ChangePassword() {
    
    
    if (this.newPassword != "" && this.newPassword === this.verifPassword) {
      // this.loaded = false;
      this.userService.updatePassword(this.currentPassword, this.newPassword, this.currentUser).subscribe(
        response => {
          this.router.navigate(['/user']);
        },
        error => {
          // this.loaded = true;
          console.log(error)
          this.openSnackBarError(error)
        }
      )
    }
    else{
     this.openSnackBarError("Le mot de passe de validation ne correspond pas avec le nouveau mot de passe")
    }
  }


  constructor(public snackBar: MatSnackBar, public sanitizer: DomSanitizer, private userService: UserApiService, public domSanitizer: DomSanitizer, private router: Router) { }

  ngOnInit() {
    this.userService.getCurrentUserData().subscribe(response => {
      this.currentUser = response;
      this.getUserImg()
      this.loaded = true;
      // conswarn(response);
      // conslog(response);

    },
      error => {
        // conserror(error);
      });

  }


  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }


}
